import { motion } from "framer-motion";
import { FaTimes } from "react-icons/fa";

export default function DashboardModal({ isOpen, onClose, item }) {
  if (!isOpen || !item) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white max-w-2xl w-full max-h-[80vh] overflow-y-auto"
      >
        {/* En-tête du modal */}
        <div className="bg-primary flex justify-between items-center p-4 border-b">
          <h2 className="font-poppins font-semibold text-xl text-white">
            {item.type === "sale"
              ? "Détails de la vente"
              : "Détails du rendez-vous"}
          </h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-100 hover:bg-gray-100 hover:text-black"
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenu du modal */}
        <div className="p-6">
          {item.type === "sale" ? (
            // Détails d'une vente
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="font-nunito text-sm text-gray-600">Code</p>
                  <p className="font-poppins font-medium">{item.code}</p>
                </div>
                <div>
                  <p className="font-nunito text-sm text-gray-600">Montant</p>
                  <p className="font-poppins font-medium text-green-600">
                    {parseInt(item.amount)} F CFA
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="font-nunito text-sm text-gray-600">
                    Méthode de paiement
                  </p>
                  <p className="font-poppins font-medium">{item.method}</p>
                </div>
                <div>
                  <p className="font-nunito text-sm text-gray-600">Statut</p>
                  <span
                    className={`inline-block px-3 py-1 text-sm font-medium ${
                      item.status === "COMPLETED"
                        ? "bg-green-100 text-green-800"
                        : item.status === "PENDING"
                        ? "bg-yellow-100 text-yellow-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
              </div>

              <div>
                <p className="font-nunito text-sm text-gray-600">Date</p>
                <p className="font-poppins font-medium">
                  {formatDate(item.created_at)}
                </p>
              </div>

              {item.client && (
                <div className="border-t pt-4">
                  <h3 className="font-poppins font-semibold mb-3">
                    Informations client
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="font-nunito text-sm text-gray-600">
                        Nom complet
                      </p>
                      <p className="font-poppins font-medium">
                        {item.client.prenom} {item.client.nom}
                      </p>
                    </div>
                    <div>
                      <p className="font-nunito text-sm text-gray-600">Email</p>
                      <p className="font-poppins font-medium">
                        {item.client.email}
                      </p>
                    </div>
                    <div>
                      <p className="font-nunito text-sm text-gray-600">
                        Téléphone
                      </p>
                      <p className="font-poppins font-medium">
                        {item.client.telephone}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            // Détails d'un rendez-vous
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="font-nunito text-sm text-gray-600">Code</p>
                  <p className="font-poppins font-medium">{item.code}</p>
                </div>
                <div>
                  <p className="font-nunito text-sm text-gray-600">
                    Date et heure
                  </p>
                  <p className="font-poppins font-medium">
                    {formatDate(item.date)}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="font-nunito text-sm text-gray-600">
                    Montant total
                  </p>
                  <p className="font-poppins font-medium text-blue-600">
                    {parseInt(item.totalAmount)} F CFA
                  </p>
                </div>
                <div>
                  <p className="font-nunito text-sm text-gray-600">Statut</p>
                  <span
                    className={`inline-block px-3 py-1 text-sm font-medium ${
                      item.status === "COMPLETED"
                        ? "bg-green-100 text-green-800"
                        : item.status === "CANCELLED"
                        ? "bg-red-100 text-red-800"
                        : item.status === "PROGRESS"
                        ? "bg-blue-100 text-blue-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
              </div>

              {item.client && (
                <div className="border-t pt-4">
                  <h3 className="font-poppins font-semibold mb-3">Client</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="font-nunito text-sm text-gray-600">
                        Nom complet
                      </p>
                      <p className="font-poppins font-medium">
                        {item.client.prenom} {item.client.nom}
                      </p>
                    </div>
                    <div>
                      <p className="font-nunito text-sm text-gray-600">
                        Téléphone
                      </p>
                      <p className="font-poppins font-medium">
                        {item.client.telephone}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {item.appointmentServices &&
                item.appointmentServices.length > 0 && (
                  <div className="border-t pt-4">
                    <h3 className="font-poppins font-semibold mb-3">
                      Services
                    </h3>
                    <div className="space-y-3">
                      {item.appointmentServices.map((service, index) => (
                        <div key={index} className="bg-gray-50 p-3">
                          <p className="font-poppins font-medium">
                            {service.service.nom}
                          </p>
                          <div className="grid grid-cols-2 gap-4 mt-2">
                            <div>
                              <p className="font-nunito text-sm text-gray-600">
                                Prix unitaire
                              </p>
                              <p className="font-poppins">
                                {parseInt(service.unitPrice)} F CFA
                              </p>
                            </div>
                            <div>
                              <p className="font-nunito text-sm text-gray-600">
                                Quantité
                              </p>
                              <p className="font-poppins">{service.quantity}</p>
                            </div>
                            <div className="col-span-2">
                              <p className="font-nunito text-sm text-gray-600">
                                Description
                              </p>
                              <p className="font-poppins text-sm">
                                {service.service.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              {item.notes && (
                <div className="border-t pt-4">
                  <h3 className="font-poppins font-semibold mb-3">Notes</h3>
                  <p className="font-poppins bg-gray-50 p-3">{item.notes}</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Pied du modal */}
        <div className="border-t p-4">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-primary text-white hover:bg-secondary-700 transition-colors"
          >
            Fermer
          </button>
        </div>
      </motion.div>
    </div>
  );
}
